module.exports = __webpack_public_path__ + "static/Artboard_2-b73a4c306c49d144f875bbd134fdfe9b.svg";